module.exports = __webpack_public_path__ + "static/media/history_bkgd.4cfd93d6.png";